import { useCallback, useMemo } from 'react';

import useEmployeeStore from '@/modules/user/stores/useEmployee.store';
import { EmployeeAddress } from '@/modules/user/user.types';

import useConfirmAddressQuery from '../queries/useConfirmAddress.query';

import useIsAddressUndeliverable from './useIsAddressUndeliverable';

const useReviewAddress = () => {
  const { employee } = useEmployeeStore();
  const { addressId, isUndeliverable, refetch } = useIsAddressUndeliverable();
  const { confirmAddress, isLoading: isConfirming } = useConfirmAddressQuery();

  const currentAddress = useMemo(
    (): EmployeeAddress | undefined =>
      employee?.addresses?.find((address: EmployeeAddress) => address?.preferredMailing),
    [employee]
  );

  const formattedAddress = useMemo(() => {
    if (!currentAddress) return '';
    return [
      currentAddress.line1,
      currentAddress.line2,
      currentAddress.city,
      currentAddress.state,
      currentAddress.zipcode,
    ]
      .filter(Boolean)
      .join(', ');
  }, [currentAddress]);

  const confirmAddressById = useCallback(async () => {
    if (addressId) {
      await confirmAddress(addressId);
    }
  }, [addressId, confirmAddress]);

  return {
    employee,
    currentAddress,
    formattedAddress,
    addressId,
    isUndeliverable,
    isConfirming,
    confirmAddressById,
    refetch,
  };
};

export default useReviewAddress;
